import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createShop',
    serviceName: 'admin',
    query: gql`
      mutation createShop($lat: String, $lng: String, $alias: String, $title: String!, $address: String) {
        createShop(lat: $lat, lng: $lng, alias: $alias, title: $title, address: $address) {
          messages
        }
      }
    `,
  },
};

export default schema;
